<template>
  <div class="message-alert ">
    <div
      class="alert alert-dismissible animate__animated animate__fadeInRight animate__fast"
      :class="'alert-' + item.status"
      v-for="(item, i) in messages"
      :key="i"
    >
      <span v-if="item.message == 'Added to favorites'" class="mr-2">
        <i class="fas fa-check-circle"></i>
      </span>

      <span v-else class="mr-2">
        <i class="fas fa-exclamation-circle"></i>
      </span>
      {{ item.message }}
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'Navbar',
    data() {
      return {}
    },
    methods: {
      updateMessage(message, status) {
        this.$store.dispatch('updateMessage', { message, status })
      },
      removeMessage(num) {
        this.$store.dispatch('removeMessage', num)
      },
      //   removeMessageWithTiming(timestamp) {
      //     const vm = this
      //     setTimeout(() => {
      //       vm.messages.forEach((item, i) => {
      //         if (item.timestamp === timestamp) {
      //           vm.messages.splice(i, 1)
      //         }
      //       })
      //     }, 5000)
      //   },
    },
    computed: {
      ...mapGetters(['messages']),
    },
    created() {
      const vm = this
      // 自定義名稱 'messsage:push'
      // message: 傳入參數
      // status: 樣式，預設值為 warning
      vm.$bus.$on('message:push', (message, status = 'warning') => {
        vm.updateMessage(message, status)
      })
    },
  }
</script>

<style scope>
  .message-alert {
    position: fixed;
    max-width: 75%;
    top: 100px;
    right: 20px;
    z-index: 1100;
  }

  .animate__animated {
    --animate-duration: 0.5s;
  }
</style>
